import {Injectable} from "@angular/core";
import * as locale from "locale";
import * as rx from "rxjs";


const DIGITAL_STORE_LOCALE = locale.getDigitalStoreLocale().locale;

@Injectable()
export class LocaleService {
	private _localeSubject = new rx.BehaviorSubject<locale.Locale>(undefined);
	private _locale = this._localeSubject.asObservable();

	private _renewalLocaleSubject = new rx.BehaviorSubject<locale.Locale>(undefined);
	private _renewalLocale = this._renewalLocaleSubject.asObservable();

	constructor() {
		let locale = this._load();
		if (locale.locale !== DIGITAL_STORE_LOCALE) {
			this._save(locale); // Don't save it if we assign the digital store as the locale
		}
		this._localeSubject.next(locale);

		this._renewalLocaleSubject.next(this._loadRenewalLocale());
	}

	getLocale() {
		return this._locale;
	}

	getRenewalLocale() {
		return this._renewalLocale;
	}

	setLocale(newLocale: locale.Locale) {
		this._save(newLocale);
		this._localeSubject.next(newLocale);
	}

	private _load() {
		return locale.getSelectedLocale();
	}

	private _loadRenewalLocale() {
		return locale.getAutoRenewalLocale();
	}

	private _save(localeObj: locale.Locale) {
		locale.selectLocale(localeObj);
	}
}
